import HTTP_METHOD from "enums/HTTP_METHOD";
import endpoints from "hooks/api/endpoints";
import useApiWrite from "hooks/api/useApiWrite";
import PublicParticipantSignupRequestDto from "types/PublicParticipantSignupRequestDto";

export default function usePostParticipantSignup() {
  const { write, ...rest } = useApiWrite();

  const postParticipantSignup = (
    data: PublicParticipantSignupRequestDto,
  ): Promise<void> =>
    write({
      url: endpoints.postPublicParticipantSignup(),
      method: HTTP_METHOD.POST,
      skipAuth: true,
      data: {
        email: data.email,
        first_name: data.firstName,
        last_name: data.lastName,
        project_id: data.projectId,
        script_id: data.scriptId,
      },
    }).then(() => undefined);

  return {
    postParticipantSignup,
    ...rest,
  };
}
